import React from 'react'
import LandingHeader from "./LandingHeader"
import FooterOther from './FooterOther'

const TermsAndConditions = () => {
    return (
        <div>
            <LandingHeader />

            <div className='max-w-[1300px] mx-auto mt-[50px] mb-[300px]'>

                <h2 className='font-semibold text-[30px]'>Terms and Conditions</h2>
                <p>
                    Welcome to Lexilearn.in, an English literacy enhancement platform developed and managed by Orden
                    Technical Services Pvt. Ltd. By accessing or using our website and services, you agree to be bound by the
                    following Terms and Conditions. Please read them carefully.
                </p>
                <div >
                    <ol type='1' className="list-decimal list-inside">
                        <li>Purpose of the Platform
                            <ul className="list-disc list-inside ml-4">
                                <li>
                                    Lexilearn.in is designed to support schools, colleges, and educational institutions in enhancing
                                    students’ reading speed and comprehension based on globally recognized Lexile measures. The
                                    platform is a supplementary tool and acts as a facilitator to the literacy efforts undertaken by
                                    educators.</li>
                            </ul>
                        </li>
                        <li>
                            Subscription and Access
                            <ul className="list-disc list-inside ml-4">
                                <li>
                                    The subscription is non-transferable and intended only for the institution or individual entity
                                    that has legally obtained it.
                                </li>
                                <li>
                                    Each subscription is for the exclusive use of the subscribing institution or individual and should
                                    not be shared, sublicensed, or resold.
                                </li>
                                <li>
                                    Sharing access credentials, system models, or any proprietary features of LexiLearn.in with third
                                    parties is strictly prohibited.
                                </li>
                            </ul>
                        </li>
                        <li>
                            Permitted Use
                            <ul className="list-disc list-inside ml-4">
                                <li>
                                    The platform must be used solely for the purpose of enhancing English literacy, specifically
                                    reading and comprehension skills, in students.
                                </li>
                                <li>
                                    Users may not use the platform for any commercial, exploitative, or unauthorized educational
                                    purposes.
                                </li>
                            </ul>
                        </li>

                        <li>
                            Intellectual Property
                            <ul className="list-disc list-inside ml-4">
                                <li>
                                    All content, design, features, and intellectual property on Lexilearn.in are owned by Orden
                                    Technical Services Pvt. Ltd.
                                </li>
                                <li>
                                    Users are not permitted to reproduce, distribute, or create derivative works based on the
                                    portal's content or functionality without written permission.
                                </li>
                            </ul>
                        </li>
                        <li>
                            User Conduct
                            <ul className="list-disc list-inside ml-4">
                                <li>
                                    Users must not engage in activities that may damage, disable, overburden, or impair the portal
                                    or its services.
                                </li>
                                <li>
                                    Users must comply with all applicable local, national, and international laws and regulations
                                    while using the platform.
                                </li>
                            </ul>
                        </li>
                        <li>
                            Data Privacy
                            <ul className="list-disc list-inside ml-4">
                                <li>
                                    Lexilearn.in adheres to applicable data privacy laws and ensures responsible handling of student
                                    and institutional data.
                                </li>
                                <li>
                                    Personal information and user performance data collected during the usage of the platform will
                                    be used only to enhance the learning experience and for internal analytical purposes. Please
                                    refer to our Privacy Policy for more details.
                                </li>
                            </ul>
                        </li>
                        <li>
                            Limitation of Liability
                            <ul className="list-disc list-inside ml-4">
                                <li>
                                    While we strive to provide accurate and effective literacy support tools, Orden Technical
                                    Services Pvt. Ltd. does not warrant that the use of Lexilearn.in will lead to guaranteed
                                    improvement in literacy skills.
                                </li>
                                <li>
                                    We are not liable for any direct, indirect, incidental, or consequential damages arising out of the
                                    use or inability to use the platform.
                                </li>
                            </ul>
                        </li>
                        <li>
                            Termination
                            <ul className="list-disc list-inside ml-4">
                                <li>
                                    We reserve the right to suspend or terminate any account found in violation of these Terms and
                                    Conditions, without prior notice.
                                </li>

                            </ul>
                        </li>
                        <li>
                            Modifications
                            <ul className="list-disc list-inside ml-4">
                                <li>
                                    We may revise these Terms and Conditions at any time. Continued use of the platform after
                                    such changes implies your acceptance of the revised terms.
                                </li>

                            </ul>
                        </li>
                        <li>
                            Governing Law
                            <ul className="list-disc list-inside ml-4">
                                <li>
                                    These Terms and Conditions shall be governed by and construed in accordance with the laws of
                                    India. Any disputes arising under or in connection with these terms shall be subject to the
                                    exclusive jurisdiction of the courts located in the Delhi NCR Region.
                                </li>

                            </ul>
                        </li>
                    </ol>

                </div>
            </div>

            <FooterOther />

        </div>
    )
}

export default TermsAndConditions